export default __webpack_public_path__ + "d0b97f60397a16714b98673f64c341c5.svg";